import React, {useState, useContext, useEffect, useRef} from 'react';
import {SettingsContext} from '../../context/SettingsProvider';
import ConfirmModal from '../../components/modals/ConfirmModal';

export default function Agreement() {
  const {termsOfService, getTermsOfService, updateTermsOfService, refreshTermsOfService} =
    useContext(SettingsContext);
  const [tosHTML, setTosHTML] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const modalRef = useRef(null);
  const [modalKey, setModalKey] = useState(0);
  // const [requireReAcceptance, setRequireReAcceptance] = useState(true);
  // const [requireReading, setRequireReading] = useState(true);
  const [confirmAcceptance, setConfirmAcceptance] = useState(false);
  const [confirmPublish, setConfirmPublish] = useState(false);

  useEffect(() => {
    if (!termsOfService) {
      getTermsOfService().then((tos) => {
        setTosHTML(tos);
      });
    } else {
      setTosHTML(termsOfService);
    }
  }, [getTermsOfService, termsOfService]);

  const handleTosHTMLChange = (event) => {
    setTosHTML(event.target.value);
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    if (!isModalOpen) {
      setModalKey((prevKey) => prevKey + 1);
    }
  };

  const publishTos = () => {
    updateTermsOfService(tosHTML)
      .then((updatedToS) => {
        setTosHTML(updatedToS);
      })
      .catch((error) => {
        console.error('Failed to update ToS:', error);
      });
  };

  const createMarkup = () => {
    return {__html: tosHTML};
  };

  const handleConfirmAcceptance = () => {
    setConfirmAcceptance(true);
  };

  const handleConfirmPublish = () => {
    setConfirmPublish(true);
  };

  const handleConfirm = () => {
    if (confirmAcceptance) {
      refreshTermsOfService({})
        .then(() => {
          console.log('Consent renewed successfully');
        })
        .catch((error) => {
          console.error('Failed to renew consent:', error);
        });
    }
    if (confirmPublish) {
      publishTos();
    }
    setConfirmAcceptance(false);
    setConfirmPublish(false);
  };

  const handleCancel = () => {
    setConfirmAcceptance(false);
    setConfirmPublish(false);
  };

  return (
    <div id="tos" className="w-full px-4 py-6 sm:w-3/4 sm:px-12">
      <div className="max-w-4xl rounded-lg bg-white p-6 shadow-lg dark:bg-stone-900">
        <div className="flex flex-col">
          <label
            htmlFor="tosHTML"
            className="mb-2 text-lg font-semibold dark:text-gray-300"
          >
            Terms of Service HTML
          </label>
          <textarea
            id="tosHTML"
            className="mb-4 w-full rounded-lg border-2 border-gray-200 p-2 dark:border-gray-700 dark:bg-stone-800 dark:text-gray-300"
            style={{minHeight: '300px'}}
            value={tosHTML}
            onChange={handleTosHTMLChange}
            placeholder="Paste your Terms of Service HTML here."
          />

          <div className="mb-4 flex items-center justify-between">
            <div className="flex items-center space-x-6">
              {/* Re-acceptance Button */}
              <div className="flex items-center">
                <button
                  onClick={handleConfirmAcceptance}
                  className="w-48 rounded-md bg-blue-600 py-2.5 font-semibold text-white transition-colors duration-200 hover:bg-blue-700 dark:bg-indigo-500 dark:hover:bg-indigo-600"
                >
                  Renew Consent
                </button>
              </div>

              {/* Reading Requirement Switch */}
              {/*<div className="flex items-center space-x-3">*/}
              {/*  <label className="text-sm leading-5 text-gray-900 dark:text-gray-300">*/}
              {/*    Require Reading*/}
              {/*  </label>*/}
              {/*  <input*/}
              {/*    id="requireReading"*/}
              {/*    type="checkbox"*/}
              {/*    checked={requireReading}*/}
              {/*    onChange={() => setRequireReading(!requireReading)}*/}
              {/*    className="form-checkbox h-4 w-4 text-blue-600 transition duration-150 ease-in-out"*/}
              {/*  />*/}
              {/*</div>*/}
            </div>

            <div>
              <button
                onClick={toggleModal}
                className="w-32 rounded-md bg-gray-600 py-2.5 font-semibold text-white transition-colors duration-200 hover:bg-gray-700 dark:bg-gray-500 dark:hover:bg-gray-600"
              >
                Preview
              </button>
              <button
                onClick={handleConfirmPublish}
                className="w-32 ml-3 rounded-md bg-blue-600 py-2.5 font-semibold text-white transition-colors duration-200 hover:bg-blue-700 dark:bg-indigo-500 dark:hover:bg-indigo-600"
              >
                Publish
              </button>
            </div>
          </div>
        </div>
      </div>
      {isModalOpen && (
        <div className="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-headline" role="dialog"
             aria-modal="true">
          <div className="flex items-center justify-center min-h-screen">
            <div className="fixed inset-0 bg-stone-950 bg-opacity-80 dark:bg-opacity-95" onClick={toggleModal}
                 aria-hidden="true"></div>
            <div
              ref={modalRef}
              className="inline-block align-middle bg-white dark:bg-stone-800 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full"
            >
              <div className="bg-white dark:bg-stone-800 dark:text-gray-300 rounded-lg pb-4 sm:p-6 sm:pb-4">
                <h3 className="text-lg pb-2 leading-6 font-medium text-gray-900 dark:text-white" id="modal-headline">
                  Terms of Service Agreement
                </h3>
                <div
                  key={modalKey}
                  className="p-2 overflow-auto border border-stone-200 dark:border-stone-600 rounded-md"
                  style={{maxHeight: '500px', minHeight: '500px'}}
                  dangerouslySetInnerHTML={createMarkup()}
                />
                <div className="flex justify-between items-center pt-4">
                  <div className="flex items-center"></div>
                  <div className="flex">
                    <button
                      type="button"
                      className="py-2.5 w-24 text-white font-semibold rounded-md bg-gray-500 hover:bg-gray-600 transition-colors duration-200"
                      onClick={toggleModal}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {(confirmAcceptance || confirmPublish) && (
        <ConfirmModal
          title={confirmAcceptance ? 'Confirm Renew Consent' : 'Confirm Publish'}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
        >
          Are you sure you want to {confirmAcceptance ? 'renew consent' : 'publish'} the Terms of Service?
          {confirmAcceptance ?
            <div className="mt-1">
              <p className="text-center text-red-500 text-sm">( warning "renew consent" will send the Terms of Service to all
                users )</p>
            </div>
            : ""}
        </ConfirmModal>
      )}

    </div>
  );
}
